import { Bell, Settings, History, Home, LifeBuoy, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
const Header = () => {
  const location = useLocation();
  const {
    user,
    isAuthenticated,
    signOut
  } = useAuth();
  const isActive = (path: string) => {
    return location.pathname === path;
  };

  // Get user initials for avatar fallback
  const getUserInitials = () => {
    if (!user) return "?";
    const email = user.email || "";
    return email.substring(0, 2).toUpperCase();
  };
  return <header className="flex items-center justify-between p-4 bg-gradient-to-r from-[#0A0D14] to-[#121520] border-b border-gray-800">
      <div className="flex items-center gap-2">
        <Link to="/" className="flex items-center">
          <div className="text-2xl font-bold">
            <span className="text-white">tok</span>
            <span className="text-tokscript-cta">collection</span>
          </div>
        </Link>

        <div className="hidden md:flex ml-8 gap-6">
          <Button variant="ghost" className={`${isActive('/') ? 'text-tokscript-cta' : 'text-gray-300'} hover:text-tokscript-cta`} size="sm" asChild>
            <Link to="/">
              <Home className="mr-2 h-4 w-4" />
              Home
            </Link>
          </Button>

          {isAuthenticated && <>
              <Button variant="ghost" className={`${isActive('/history') ? 'text-tokscript-cta' : 'text-gray-300'} hover:text-tokscript-cta`} size="sm" asChild>
                <Link to="/history">
                  <History className="mr-2 h-4 w-4" />
                  History
                </Link>
              </Button>
              <Button variant="ghost" className={`${isActive('/settings') ? 'text-tokscript-cta' : 'text-gray-300'} hover:text-tokscript-cta`} size="sm" asChild>
                <Link to="/settings">
                  <Settings className="mr-2 h-4 w-4" />
                  Settings
                </Link>
              </Button>
            </>}

          <Button variant="ghost" className={`${isActive('/support') ? 'text-tokscript-cta' : 'text-gray-300'} hover:text-tokscript-cta`} size="sm" asChild>
            <Link to="/support">
              <LifeBuoy className="mr-2 h-4 w-4" />
              Support
            </Link>
          </Button>
        </div>
      </div>

      <div className="flex items-center gap-4">
        {isAuthenticated ? <>
            <Button variant="ghost" size="icon" className="text-gray-300 hover:text-tokscript-cta">
              <Bell className="h-5 w-5" />
            </Button>
            
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <div className="flex items-center gap-2 cursor-pointer">
                  <Avatar>
                    <AvatarImage src={user?.user_metadata?.avatar_url} />
                    <AvatarFallback className="bg-tokscript-card text-tokscript-text">{getUserInitials()}</AvatarFallback>
                  </Avatar>
                  <div className="hidden md:block text-left">
                    <div className="font-medium text-gray-100">
                      {user?.user_metadata?.full_name || user?.email?.split('@')[0] || "User"}
                    </div>
                    <div className="text-xs text-gray-400">{user?.email}</div>
                  </div>
                </div>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-56 bg-tokscript-card border-gray-700">
                <DropdownMenuItem className="text-gray-200 focus:bg-gray-700 focus:text-white cursor-pointer" asChild>
                  <Link to="/settings">Account Settings</Link>
                </DropdownMenuItem>
                <DropdownMenuSeparator className="bg-gray-700" />
                <DropdownMenuItem className="text-gray-200 focus:bg-gray-700 focus:text-white cursor-pointer" onClick={() => signOut()}>
                  Log out
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </> : <div className="flex items-center gap-2">
            <Button variant="ghost" className="text-gray-300 hover:text-tokscript-cta" size="sm" asChild>
              <Link to="/login">Log In</Link>
            </Button>
            <Button className="bg-tokscript-cta hover:bg-tokscript-cta/90 text-black" size="sm" asChild>
              <Link to="/login">
                <LogIn className="mr-2 h-4 w-4" />
                Sign Up
              </Link>
            </Button>
          </div>}
      </div>
    </header>;
};
export default Header;